// extracted by mini-css-extract-plugin
module.exports = {"fullWidth":"VaultPositionControls_fullWidth__dyJGi"};